import React, { useState } from 'react';
import { Col, Card, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';

const { FormatMoney } = require('format-money-js');

const fmDecimal = new FormatMoney({
  decimals: 2,
});

const CounterCard = ({ icon, title, counter, tooltip = '', path = '' }) => {

  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(counter);
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  const isClabe = title.toLowerCase() === 'clabe stp';

  const content = (
    <Card className={`h-100 ${!isClabe ? 'hover-scale-up cursor-pointer' : ''}`}>
      <Card.Body className="d-flex flex-column align-items-center px-2 py-2">

        <div className="d-flex align-self-start gap-2 align-items-center flex-wrap w-100 justify-content-between">
          <div className="d-flex gap-2 align-items-center">
            <div className="sw-5 d-flex align-items-center">
              <img src={`/img/iconos/${icon}.svg`} width={32} alt="card image" />
            </div>
            <p className="text-dark font-weight-bold text-semi-large m-0 lh-1-25 text-left sw-18">
              {title.toUpperCase()}
            </p>
          </div>
        </div>

        {title.toLowerCase() === 'saldo actual' ? (
          <p className="text-primary text-semi-large mt-3">
            {fmDecimal.from(counter, { symbol: '$' })}
          </p>
        ) : (
          <p className="text-primary text-semi-large mt-3 d-flex align-items-center">
            {counter}

            {isClabe && (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip>
                    {copied ? 'Copiado' : 'Copiar'}
                  </Tooltip>
                }
              >
                <img
                  src="https://cdn-icons-png.flaticon.com/512/60/60990.png"
                  width={12}
                  style={{ cursor: 'pointer', marginLeft: '5px' }}
                  alt="copiar"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleCopy();
                  }}
                />
              </OverlayTrigger>
            )}
          </p>
        )}

      </Card.Body>
    </Card>
  );

  if (isClabe) {
    return (
      <Col xs="12" lg="5" className="p-0 w-45">
        {content}
      </Col>
    );
  }

  return (
    <Col xs="12" lg="5" className="p-0 w-45">
      <OverlayTrigger
        delay={{ show: 1000, hide: 0 }}
        placement="top"
        overlay={<Tooltip id="tooltip-top">{tooltip}</Tooltip>}
      >
        <NavLink to={path}>{content}</NavLink>
      </OverlayTrigger>
    </Col>
  );
};

export default CounterCard;